import http, { cb } from "../http-common";

const route = "prs"

class ProcessService {
  get_sales() {
    return http().get(`/${route}/sales`).then(cb);
  }

  get_income() {
    return http().get(`/${route}/income`).then(cb);
  }

  search_sales(month) {
    return http().get(`/${route}/sales/${month}`).then(cb);
  }

  search_income(month) {
    return http().get(`/${route}/income/${month}`).then(cb);
  }


  get_audit(id, e) {
    return http().get(`/${route}/audit/${e}&${id}`).then(cb);
  }

  mail_verify_request(data) {
    return http().post(`/${route}/mail/verify_request`, data).then(cb);
  }

  verify_request(data) {
    return http().post(`/${route}/verify`, data);
  }

  mail_verify_request_public(data) {
    return http().post(`/${route}/mail/verify_request_public`, data);
  }


}

export default new ProcessService();